import { gql, useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

const FUND_DEAL_CONSENT_INVITE_QUERY = gql`
  query FundDealConsentInvite($fundDealInviteId: String!) {
    fundDealConsentInvite(id: $fundDealInviteId) {
      id
      fund {
        id
      }
      dealClosing {
        id
      }
      deal {
        id
      }
    }
  }
`;

const FundDealConsentInvite = () => {
  const { fundDealInviteId } = useParams<{ fundDealInviteId: string }>();
  const { loading, error, data, refetch } = useQuery(FUND_DEAL_CONSENT_INVITE_QUERY, {
    variables: {
      fundDealInviteId: fundDealInviteId || '',
    },
  });

  if (loading) return <LoadingIndicator />;

  if (!data || error) return <ErrorMessage message="Error loading fund deal consent invite" />;

  const { fund, dealClosing, deal } = data.fundDealConsentInvite;

  if (fund.id && dealClosing.id) {
    return (
      <Navigate
        to={`/invest/fund-invest-consent/${fund.id}/deal/${deal.id}/closing/${dealClosing.id}`}
      />
    );
  }

  return <div></div>;
};

export default FundDealConsentInvite;
